import PricingCardsWithQuiz from 'molecules/PricingCardsWithQuiz/PricingCardsWithQuiz';
import React, { useState } from 'react';
import usePricingCards from 'src/hooks/usePricingCards';

const PricingDescription = (): JSX.Element => {
  const [activePriceMode, setActivePriceMode] = useState<'monthly' | 'annual'>('annual');
  const pricingItems = usePricingCards(activePriceMode);

  return (
    <PricingCardsWithQuiz
      pricingItems={pricingItems}
      activePriceMode={activePriceMode}
      setActivePriceMode={setActivePriceMode}
      priceBlockMinHeight={307}
    />
  );
};

export default PricingDescription;
